export default __webpack_public_path__ + "static/media/logo.a0c6fc28.png";